<template>
  <div class="sec-list-item edu-item">
    <label class="edu-item__badge">
      {{ contentTypeName }}
    </label>
    <div class="edu-item__content">
      <i class="uil-list-ul uk-sortable-handle edu-item__drag"></i>
      <a class="edu-item__name" @click="$emit('edit', educationIndex)">
        {{ education.name }}
      </a>
    </div>
    <div class="edu-item__actions">
      <button
        class="btn btn-icon btn-hover btn-sm btn-circle edu-item__action-btn"
        :uk-tooltip="`title: ${$t('general.edit')}`"
        @click="$emit('edit', educationIndex)"
      >
        <i class="icon-feather-edit"></i>
      </button>
      <button
        class="btn btn-icon btn-hover btn-sm btn-circle edu-item__action-btn edu-item__action-btn--delete"
        :uk-tooltip="`title: ${$t('general.remove')}`"
        @click="$emit('delete', educationIndex)"
      >
        <i class="icon-feather-trash"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EducationItemCard",
  props: {
    education: {
      type: Object,
      required: true
    },
    educationIndex: {
      type: Number,
      required: true
    },
    contentTypeName: {
      type: String,
      default: ""
    }
  },
  emits: ['edit', 'delete']
};
</script>

<style scoped>
.edu-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  overflow: visible;
  background: #fff;
  border: 1px solid #d4d4d4;
  border-radius: 10px;
  padding: 12px 12px 10px;
  margin-bottom: 8px;
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.4;
}

.edu-item__badge {
  position: absolute;
  top: -9px;
  left: 10px;
  z-index: 1;
  margin: 0;
  font-size: 0.7rem;
  font-weight: 500;
  background: #3e416d;
  padding: 1px 7px;
  border-radius: 3px;
  color: white;
  line-height: 1.4;
  white-space: nowrap;
  pointer-events: none;
}

.edu-item__content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.edu-item__drag {
  flex-shrink: 0;
  cursor: grab;
  color: #94a3b8;
  font-size: 16px;
}

.edu-item__name {
  cursor: pointer;
  color: #1e293b;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.edu-item__name:hover {
  color: var(--primaryColor, #3e416d);
}

.edu-item__actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.edu-item__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  padding: 0;
  border-radius: 8px;
  font-size: 16px;
  color: #64748b;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.edu-item__action-btn:active {
  transform: scale(0.95);
  opacity: 0.85;
}

.edu-item__action-btn--delete {
  color: #dc3545;
}

/* ─── Mobile ─── */
@media (max-width: 959px) {
  .edu-item {
    flex-wrap: wrap;
    gap: 8px;
    padding: 14px 12px 10px;
    font-size: 16px;
  }

  .edu-item__badge {
    top: -9px;
    left: 8px;
    font-size: 11px;
    padding: 2px 8px;
  }

  .edu-item__content {
    flex: 1 1 0;
    min-width: 0;
    gap: 8px;
  }

  .edu-item__name {
    font-size: 16px;
    white-space: normal;
    word-break: break-word;
  }

  .edu-item__action-btn {
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    font-size: 18px;
    border-radius: 10px;
  }
}

/* ─── Desktop hover ─── */
@media (hover: hover) and (pointer: fine) {
  .edu-item__action-btn:hover {
    background-color: #f1f5f9;
  }

  .edu-item__action-btn--delete:hover {
    background-color: #fef2f2;
  }
}

/* ─── Reduced motion ─── */
@media (prefers-reduced-motion: reduce) {
  .edu-item__action-btn:active {
    transform: none;
  }
}
</style>
